import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import html from '../Resources/Images/LanguageImages/html5.png'
import css from '../Resources/Images/LanguageImages/css3.png'
import js from '../Resources/Images/LanguageImages/js.png'
import git from '../Resources/Images/LanguageImages/git.png'
import mongodb from '../Resources/Images/LanguageImages/mongodb.png'
import nodejs from '../Resources/Images/LanguageImages/nodejs.png'
import react from '../Resources/Images/LanguageImages/react.png'
import reactredux from '../Resources/Images/LanguageImages/redux.png'
import mern from '../Resources/Images/LanguageImages/mern.png'
const Skills = () => {
    const skills = [
        {
            img:html,
            title:'HTML'
        },
        {
            img:css,
            title:'CSS'
        },
        {
            img:js,
            title:'Javascript'
        },
        {
            img:git,
            title:'Git/Github'
        },
        {
            img:mongodb,
            title:'MongoDB'
        },
        {
            img:nodejs,
            title:'NodeJS'
        },
        {
            img:react,
            title:'ReactJS'
        },
        {
            img:reactredux,
            title:'Redux'
        },
        {
            img:mern,
            title:'MERN'
        }
    ]

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 0.6,
                staggerChildren: 0.1
            }
        },
        exit: {
            opacity: 0,
            transition: {
                duration: 0.4,
                staggerChildren: 0.05,
                staggerDirection: -1
            }
        }
    };

    const itemVariants = {
        hidden: { 
            opacity: 0, 
            y: 50,
            scale: 0.8
        },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                duration: 0.6,
                ease: "easeOut"
            }
        },
        exit: {
            opacity: 0,
            y: -50,
            scale: 0.8,
            transition: {
                duration: 0.4,
                ease: "easeIn"
            }
        }
    };

    const skillCardVariants = {
        hover: {
            y: -10,
            scale: 1.05,
            boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.2)",
            transition: {
                duration: 0.3,
                ease: "easeInOut"
            }
        },
        tap: {
            scale: 0.95
        }
    };

    return (
        <Container id='skills'>
            <motion.h1
                initial={{ opacity: 0, y: -30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                Skills
            </motion.h1>
            <motion.div 
                className='skillsContainer'
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                exit="exit"
                viewport={{ once: false, margin: "-100px" }}
            >
                {skills.map((ele, index) => (
                    <motion.div 
                        key={index}
                        variants={itemVariants}
                        whileHover="hover"
                        whileTap="tap"
                        custom={index}
                    >
                        <motion.img 
                            src={ele.img} 
                            alt={ele.title} 
                            width='70px' 
                            height='70px'
                            whileHover={{ 
                                rotate: [0, -10, 10, -10, 0],
                                transition: { duration: 0.5 }
                            }}
                        />
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.2 }}
                        >
                            {ele.title}
                        </motion.p>
                    </motion.div>
                ))}
            </motion.div>
        </Container>
    )
}

const Container = styled.div`
    width:100%;
    margin:auto;
    
    h1{
        color:#01a479;
        text-transform:uppercase;
    }

    .skillsContainer{
        width:85%;
        margin:auto;
        display:grid;
        grid-template-columns: repeat(auto-fit,minmax(120px,max-content));
        justify-content:center;
        padding:30px;
        gap:20px;
    }

    .skillsContainer>div{
       display:flex;
       align-items:center;
       flex-direction:column;
       box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
       padding: 20px 0px 10px 0px;
       border-radius: 10px;
       cursor: pointer;
       background: white;
       transition: all 0.3s ease;
    }

    .skillsContainer>div:hover{
        transform: translateY(-5px);
        box-shadow: rgba(0, 0, 0, 0.25) 0px 10px 25px 0px;
    }
`

export default Skills